import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "mobx-react";
import App from "./App";
// import registerServiceWorker from "./registerServiceWorker";
import { unregister } from "./registerServiceWorker";

// Stores
// import userStore from "./stores/userStore";
import overlayStore from "./stores/overlayStore";
import eventStore from "./stores/eventStore";
import pollStore from "./stores/pollStore";
import gcxStore from "./stores/gcxStore";

import "./scss/index.scss";

import ReactGA from "react-ga";
ReactGA.initialize("UA-153647981-4");
ReactGA.pageview(window.location.pathname + window.location.search);

const stores = {
  overlayStore,
  eventStore,
  pollStore,
  gcxStore,
};

ReactDOM.render(
  <Provider {...stores}>
    <App />
  </Provider>,
  document.getElementById("root")
);
// registerServiceWorker();
unregister();
